module.exports = __webpack_public_path__ + "static/media/affiliate-program.9fe65daa.png";